/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ListVisOrgRequest as UserServiceContractListVisOrgRequest } from '../models/UserService/Contract/list-vis-org-request';
import { VisOrg as UserServiceContractVisOrg } from '../models/UserService/Contract/vis-org';
import { VisOrgFiltered as UserServiceContractVisOrgFiltered } from '../models/UserService/Contract/vis-org-filtered';

@Injectable({
  providedIn: 'root',
})
export class VisOrgService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiUsersListVisOrgGet
   */
  static readonly ApiUsersListVisOrgGetPath = '/api/Users/ListVisOrg';

  /**
   * List of visible organizations.
   *
   * ### Claim
   *  boservice.users.listvisorg
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUsersListVisOrgGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiUsersListVisOrgGet$Plain$Response(params?: {

    /**
     * Interface language
     */
    lang?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<UserServiceContractVisOrg>>> {

    const rb = new RequestBuilder(this.rootUrl, VisOrgService.ApiUsersListVisOrgGetPath, 'get');
    if (params) {
      rb.query('lang', params.lang, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<UserServiceContractVisOrg>>;
      })
    );
  }

  /**
   * List of visible organizations.
   *
   * ### Claim
   *  boservice.users.listvisorg
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUsersListVisOrgGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiUsersListVisOrgGet$Plain(params?: {

    /**
     * Interface language
     */
    lang?: string;
  },
  context?: HttpContext

): Observable<Array<UserServiceContractVisOrg>> {

    return this.apiUsersListVisOrgGet$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<UserServiceContractVisOrg>>) => r.body as Array<UserServiceContractVisOrg>)
    );
  }

  /**
   * List of visible organizations.
   *
   * ### Claim
   *  boservice.users.listvisorg
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUsersListVisOrgGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiUsersListVisOrgGet$Response(params?: {

    /**
     * Interface language
     */
    lang?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<UserServiceContractVisOrg>>> {

    const rb = new RequestBuilder(this.rootUrl, VisOrgService.ApiUsersListVisOrgGetPath, 'get');
    if (params) {
      rb.query('lang', params.lang, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<UserServiceContractVisOrg>>;
      })
    );
  }

  /**
   * List of visible organizations.
   *
   * ### Claim
   *  boservice.users.listvisorg
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUsersListVisOrgGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiUsersListVisOrgGet(params?: {

    /**
     * Interface language
     */
    lang?: string;
  },
  context?: HttpContext

): Observable<Array<UserServiceContractVisOrg>> {

    return this.apiUsersListVisOrgGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<UserServiceContractVisOrg>>) => r.body as Array<UserServiceContractVisOrg>)
    );
  }

  /**
   * Path part for operation apiUsersListVisOrgPost
   */
  static readonly ApiUsersListVisOrgPostPath = '/api/Users/ListVisOrg';

  /**
   * Getting a list of visible organizations/departments.
   *
   * ### Claim
   *  boservice.users.listvisorg
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUsersListVisOrgPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUsersListVisOrgPost$Plain$Response(params?: {

    /**
     * Interface language
     */
    lang?: string;
    body?: UserServiceContractListVisOrgRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<UserServiceContractVisOrgFiltered>>> {

    const rb = new RequestBuilder(this.rootUrl, VisOrgService.ApiUsersListVisOrgPostPath, 'post');
    if (params) {
      rb.query('lang', params.lang, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<UserServiceContractVisOrgFiltered>>;
      })
    );
  }

  /**
   * Getting a list of visible organizations/departments.
   *
   * ### Claim
   *  boservice.users.listvisorg
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUsersListVisOrgPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUsersListVisOrgPost$Plain(params?: {

    /**
     * Interface language
     */
    lang?: string;
    body?: UserServiceContractListVisOrgRequest
  },
  context?: HttpContext

): Observable<Array<UserServiceContractVisOrgFiltered>> {

    return this.apiUsersListVisOrgPost$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<UserServiceContractVisOrgFiltered>>) => r.body as Array<UserServiceContractVisOrgFiltered>)
    );
  }

  /**
   * Getting a list of visible organizations/departments.
   *
   * ### Claim
   *  boservice.users.listvisorg
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUsersListVisOrgPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUsersListVisOrgPost$Response(params?: {

    /**
     * Interface language
     */
    lang?: string;
    body?: UserServiceContractListVisOrgRequest
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<UserServiceContractVisOrgFiltered>>> {

    const rb = new RequestBuilder(this.rootUrl, VisOrgService.ApiUsersListVisOrgPostPath, 'post');
    if (params) {
      rb.query('lang', params.lang, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<UserServiceContractVisOrgFiltered>>;
      })
    );
  }

  /**
   * Getting a list of visible organizations/departments.
   *
   * ### Claim
   *  boservice.users.listvisorg
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUsersListVisOrgPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUsersListVisOrgPost(params?: {

    /**
     * Interface language
     */
    lang?: string;
    body?: UserServiceContractListVisOrgRequest
  },
  context?: HttpContext

): Observable<Array<UserServiceContractVisOrgFiltered>> {

    return this.apiUsersListVisOrgPost$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<UserServiceContractVisOrgFiltered>>) => r.body as Array<UserServiceContractVisOrgFiltered>)
    );
  }

}
